import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConfig = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "config-icon",
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .secc12 {\n        fill: #0573A9;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "secc12",
			d: "M.8999,2.54971h2.28418c.22595.79578.92725,1.3501,1.81592,1.3501s1.59003-.55432,1.81598-1.3501h6.38422c.30371,0,.5498-.24609.5498-.5498s-.24609-.5498-.5498-.5498h-6.38202c-.19464-.68701-.74323-1.19434-1.46271-1.31982l-.35547-.03029c-.88873,0-1.5899.55432-1.81592,1.3501H.8999c-.30371,0-.5498.24609-.5498.5498s.24609.5498.5498.5498h0ZM5,1.1c.52148,0,.8999.37842.8999.8999s-.37842.8999-.8999.8999-.8999-.37842-.8999-.8999.37842-.8999.8999-.8999Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "secc12",
			d: "M13.2002,10.94961h-7.78412c-.22595-.79565-.92731-1.34961-1.81598-1.34961s-1.58997.55396-1.81592,1.34961h-.88428c-.30371,0-.5498.24609-.5498.5498s.24609.5498.5498.5498h.88428c.22595.79596.92719,1.35059,1.81592,1.35059s1.59003-.55463,1.81598-1.35059h7.78412c.30371,0,.5498-.24609.5498-.5498s-.24609-.5498-.5498-.5498ZM3.6001,12.39981c-.52148,0-.8999-.37891-.8999-.90039s.37842-.89941.8999-.89941.8999.37793.8999.89941-.37842.90039-.8999.90039Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "secc12",
			d: "M13.2002,6.14981h-.98425c-.22583-.79578-.92682-1.3501-1.81555-1.3501s-1.59027.55432-1.81641,1.3501H.8999c-.30371,0-.5498.24609-.5498.5498s.24609.5498.5498.5498h7.68402c.22607.79614.92767,1.35059,1.81647,1.35059s1.58978-.55444,1.81561-1.35059h.98419c.30371,0,.5498-.24609.5498-.5498s-.24609-.5498-.54979-.5498ZM10.40039,7.6c-.52148,0-.90039-.37891-.90039-.90039s.37891-.8999.90039-.8999.89941.37842.89941.8999-.37793.90039-.89941.90039Z"
		})
	]
});
export default SvgConfig;
